/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-06-25T18:30:18.955
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentViewOrderRetreatEditInit,
	getRentViewOrderRetreatView
} from '@api/rentmanage/RentViewOrderRetreat';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getRentViewOrderRetreatEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentViewOrderRetreatEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentViewOrderRetreatView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentViewOrderRetreatView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
